import React, { useEffect, Children } from 'react';
export function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#f8f8f8] text-[#1a1a2e] font-sans text-base leading-relaxed" data-id="element-2784">
      {/* Top Bar */}
      <div className="bg-[#1a0647] px-5 py-3 md:px-8 flex items-center gap-3" data-id="element-2785">
        <span className="font-bold text-lg text-white tracking-wide" data-id="element-2786">
          Caveo
        </span>
        <div className="w-px h-4 bg-white/25" data-id="element-2787"></div>
        <span className="text-[13px] text-white/60 tracking-widest uppercase" data-id="element-2788">
          Legal
        </span>
      </div>

      {/* Hero */}
      <div className="relative bg-gradient-to-br from-[#1a0647] via-[#2d0a7a] to-[#3a0f9e] px-5 pt-16 pb-12 md:pt-20 md:pb-16 text-center overflow-hidden" data-id="element-2789">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at 70% 40%, rgba(133,40,226,0.35) 0%, transparent 65%), radial-gradient(ellipse at 20% 80%, rgba(1,206,209,0.12) 0%, transparent 55%)'
      }} data-id="element-2790"></div>

        <div className="relative z-10" data-id="element-2791">
          <div className="inline-block bg-[#b063ff]/20 border border-[#b063ff]/30 text-[#b063ff] text-xs font-medium tracking-widest uppercase px-4 py-1.5 rounded-full mb-5" data-id="element-2792">
            Legal &amp; Privacy
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-4" data-id="element-2793">
            Privacy Policy
          </h1>
          <p className="text-base text-white/65 max-w-lg mx-auto mb-7" data-id="element-2794">
            AppEmbrace, Inc. d/b/a Caveo — plain English, no fine print.
          </p>
          <div className="flex justify-center gap-6 flex-wrap" data-id="element-2795">
            <span className="text-[13px] text-white/50" data-id="element-2796">
              <strong className="text-white/85 font-semibold" data-id="element-2797">
                Effective:
              </strong>{' '}
              February 27, 2026
            </span>
            <span className="text-[13px] text-white/50" data-id="element-2798">
              <strong className="text-white/85 font-semibold" data-id="element-2799">
                Last Updated:
              </strong>{' '}
              February 2026
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-[820px] mx-auto px-5 md:px-6 pb-20" data-id="element-2800">
        {/* Intro */}
        <div className="bg-white border-l-4 border-[#01ced1] rounded-xl p-6 md:p-8 my-10 md:my-12 shadow-[0_2px_12px_rgba(26,6,71,0.07)]" data-id="element-2801">
          <p className="text-[#555577] text-[15px] mb-3 last:mb-0" data-id="element-2802">
            At Caveo, we believe privacy should be simple and clear. We only
            collect the minimum personal information necessary to provide our
            services, and we never sell your data. This policy explains what we
            collect, why we collect it, and how we use it when you access
            JoinCaveo.com or any Caveo product or service. We've written it in
            plain English on purpose, because that's how we do everything.
          </p>
          <p className="text-[#555577] text-[15px] mb-0" data-id="element-2803">
            Questions? Email us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-2804">
              privacy@caveohq.com
            </a>{' '}
            and a real person will respond.
          </p>
        </div>

        {/* Section 1 - Who We Are */}
        <div className="mb-12" data-id="element-2805">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2806">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2807">
              1
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2808">
              Who We Are
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5 last:mb-0" data-id="element-2809">
            Caveo is operated by AppEmbrace, Inc., a Delaware C-Corporation
            headquartered in Oakland, California. We are the operator of
            JoinCaveo.com and all related Caveo products and services.
            References to "Caveo," "we," "us," or "our" throughout this policy
            refer to AppEmbrace, Inc.
          </p>
        </div>

        {/* Section 2 - What Information We Collect */}
        <div className="mb-12" data-id="element-2810">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2811">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2812">
              2
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2813">
              What Information We Collect
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2814">
            We collect only what we need to give you a great experience.
          </p>

          <div className="my-5" data-id="element-2815">
            <h3 className="text-[15px] font-bold text-[#8528e2] mb-2.5 uppercase tracking-[0.06em]" data-id="element-2816">
              Information We May Collect
            </h3>
            <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2817">
              {['Account information: your name, email address, and login credentials.', 'Technical information: device type, operating system, and browser.', 'Usage data: completion of checklists, alerts delivered, and progress scores.', 'Behavioral data: website pages and content visited, and usage of sections of the platform, to help us improve the product and user experience.', 'Household profile information: number of family members, general age ranges, and device types, used solely to personalize your experience.', 'Payment information: processed securely by third-party providers. We do not store full payment card numbers on our servers.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2818">
                  <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2819">
                    →
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-2820">
            <strong className="text-[#1a0647] font-semibold" data-id="element-2821">
              We do not sell your data.
            </strong>{' '}
            We do not collect or store sensitive data such as credit card
            numbers, Social Security numbers, or passwords to your external
            accounts. We do not track your activity outside of the Caveo
            platform.
          </div>
        </div>

        {/* Section 3 - How We Use Your Information */}
        <div className="mb-12" data-id="element-2822">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2823">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2824">
              3
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2825">
              How We Use Your Information
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2826">
            We use collected data to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2827">
            {['Provide and improve our services.', 'Personalize your experience and deliver relevant security modules and recommendations.', 'Send alerts, reminders, and important updates related to your account and household security.', 'Generate anonymized, aggregate reports for product improvement.', 'Respond to your support requests and questions.', 'Process payments for subscriptions and add-on services.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2828">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2829">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-2830">
            We do not use your information for advertising, and we do not allow
            third parties to advertise through Caveo products.
          </p>
        </div>

        {/* Section 4 - Data Protection */}
        <div className="mb-12" data-id="element-2831">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2832">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2833">
              4
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2834">
              Data Protection
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2835">
            As a cybersecurity company, we hold ourselves to high standards.
            Here is what that means in practice:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2836">
            {['All personal data is encrypted in transit and at rest.', 'Access to personal data is limited to employees with a legitimate business need.', 'Vendors and service providers are required to follow strict security practices and are contractually bound to protect your data.', 'We conduct regular security reviews of our platform and infrastructure.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2837">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2838">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-2839">
            We encourage you to use a strong, unique password for your Caveo
            account and to enable Multi-Factor Authentication (MFA) when
            available.
          </p>
        </div>

        {/* Section 5 - Family Plans and Multi-User Accounts */}
        <div className="mb-12" data-id="element-2840">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2841">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2842">
              5
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2843">
              Family Plans and Multi-User Accounts
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2844">
            Caveo is designed for multi-generational families. Some plans
            include multiple users under one account. Here is how we handle
            that:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2845">
            {['Each family member has their own individual profile with their own privacy settings.', 'Sharing data with a designated Family IT Lead is always opt-in and voluntary, never automatic.', "Individual family members own their own data. No family member can access another member's data without that person's explicit consent.", 'Account administrators can view aggregate household security scores but cannot access individual activity logs or personal data without permission.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2846">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2847">
                  →
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Section 6 - Third-Party Sharing */}
        <div className="mb-12" data-id="element-2848">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2849">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2850">
              6
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2851">
              Third-Party Sharing
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2852">
            Caveo does not share personal information with third parties without
            your consent, except as required by law. Specifically:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2853">
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-2854">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2855">→</span>
              <span data-id="element-2856">
                <strong className="text-[#1a0647] font-semibold" data-id="element-2857">
                  Service providers:
                </strong>{' '}
                We work with vendors who help us operate the platform, including
                Supabase (authentication and database), Vercel (hosting), and
                PostHog (analytics). These vendors access data only as needed
                and are contractually required to protect it.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-2858">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2859">→</span>
              <span data-id="element-2860">
                <strong className="text-[#1a0647] font-semibold" data-id="element-2861">
                  Legal requirements:
                </strong>{' '}
                We may disclose information if required by law, court order, or
                government request, or to protect the rights, property, or
                safety of Caveo, our users, or others.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-2862">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2863">→</span>
              <span data-id="element-2864">
                <strong className="text-[#1a0647] font-semibold" data-id="element-2865">
                  Business transfers:
                </strong>{' '}
                In the event of a merger, acquisition, or sale of assets, user
                information may be transferred. We will notify you before any
                such transfer takes effect.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2866">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2867">→</span>
              <span data-id="element-2868">
                <strong className="text-[#1a0647] font-semibold" data-id="element-2869">
                  With your consent:
                </strong>{' '}
                We will not share your information for any other purpose without
                asking you first.
              </span>
            </li>
          </ul>
        </div>

        {/* Section 7 - Your Privacy Rights */}
        <div className="mb-12" data-id="element-2870">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2871">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2872">
              7
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2873">
              Your Privacy Rights
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2874">
            Depending on your location, you may have rights under applicable
            privacy laws such as the California Consumer Privacy Act (CCPA) or
            the General Data Protection Regulation (GDPR). These rights may
            include the ability to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-2875">
            {['Access the personal information we hold about you.', 'Correct inaccurate or incomplete information.', 'Request deletion of your personal information.', 'Restrict or object to certain uses of your data.', 'Opt out of the sale of your personal information. (Note: Caveo does not sell personal information.)', 'Non-discrimination for exercising your privacy rights.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-2876">
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-2877">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-2878">
            To exercise any of these rights, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-2879">
              privacy@caveohq.com
            </a>
            . We will respond within 45 days.
          </p>
        </div>

        {/* Section 8 - Children's Privacy */}
        <div className="mb-12" data-id="element-2880">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2881">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2882">
              8
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2883">
              Children's Privacy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2884">
            Caveo supports multi-generational households, including older teens.
            We do not knowingly collect personal information from children under
            the age of 13 without verifiable parental consent. If a family plan
            includes a member under 13, the account holder is responsible for
            ensuring appropriate consent has been provided.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-2885">
            If you believe a minor's data has been collected without proper
            consent, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-2886">
              privacy@caveohq.com
            </a>{' '}
            and we will act promptly.
          </p>
        </div>

        {/* Section 9 - Cookies and Tracking */}
        <div className="mb-12" data-id="element-2887">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2888">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2889">
              9
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2890">
              Cookies and Tracking
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2891">
            We use cookies and similar technologies to keep you logged in,
            remember your preferences, and collect analytics. You can control
            cookie settings through your browser. Disabling cookies may limit
            certain functionality on the platform.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-2892">
            We do not use cookies to track your activity outside of the Caveo
            platform.
          </p>
        </div>

        {/* Section 10 - Data Retention */}
        <div className="mb-12" data-id="element-2893">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2894">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2895">
              10
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2896">
              Data Retention
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-2897">
            We keep your personal information only as long as necessary to
            provide our services or as required by law. If you close your
            account, we will delete or anonymize your personal data within 90
            days, unless we are legally required to retain it longer.
          </p>
        </div>

        {/* Section 11 - Affiliate Disclosure (FTC-Compliant) */}
        <div className="mb-12" data-id="element-2898">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2899">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2900">
              11
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2901">
              Affiliate Disclosure (FTC-Compliant)
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2902">
            Some recommendations on the Caveo platform may include affiliate
            links. This means Caveo may earn a commission if you purchase a
            product or service through one of those links, at no additional cost
            to you. This is disclosed in compliance with FTC guidelines.
          </p>
          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-2903">
            <strong className="text-[#1a0647] font-semibold" data-id="element-2904">
              Our commitment to you:
            </strong>{' '}
            These commissions NEVER influence our recommendations. We repeat:
            They will NEVER influence our recommendations.
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-2905">
            All suggestions are based on our independent evaluation of what we
            believe will best serve your family's needs, devices, comfort level,
            and budget. We maintain the same recommendation integrity whether or
            not an affiliate relationship exists.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-2906">
            When we recommend products like a router, a service provider, or a
            password manager, it's because they represent the best solution for
            your situation, not because they offer affiliate revenue.
          </p>
        </div>

        {/* Section 12 - Changes to This Policy */}
        <div className="mb-12" data-id="element-2907">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2908">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2909">
              12
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2910">
              Changes to This Policy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-2911">
            We may update this Privacy Policy from time to time. When we do, we
            will revise the "Last Updated" date at the top of this page and, for
            significant changes, notify you by email or via an in-app
            notification. Your continued use of Caveo after changes take effect
            constitutes your acceptance of the updated policy.
          </p>
        </div>

        {/* Section 13 - Contact Us */}
        <div className="mb-12" data-id="element-2912">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-2913">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-2914">
              13
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-2915">
              Contact Us
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-4" data-id="element-2916">
            If you have questions, concerns, or requests related to this Privacy
            Policy, please reach out:
          </p>

          <div className="bg-[#1a0647] rounded-xl p-7 md:p-10 mt-4" data-id="element-2917">
            <h3 className="text-lg font-bold text-white mb-4" data-id="element-2918">
              AppEmbrace, Inc. d/b/a Caveo
            </h3>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-2919">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-2920">
                Attn
              </span>
              <span className="text-[15px] text-white/85" data-id="element-2921">
                Jason Phillips, CEO
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-2922">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-2923">
                Email
              </span>
              <span className="text-[15px] text-white/85" data-id="element-2924">
                <a href="mailto:privacy@caveohq.com" className="text-[#b063ff] hover:underline" data-id="element-2925">
                  privacy@caveohq.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-2926">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-2927">
                Website
              </span>
              <span className="text-[15px] text-white/85" data-id="element-2928">
                <a href="https://JoinCaveo.com" className="text-[#b063ff] hover:underline" data-id="element-2929">
                  JoinCaveo.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-2930">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-2931">
                Location
              </span>
              <span className="text-[15px] text-white/85" data-id="element-2932">
                Oakland, California
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-[#eae6dc] text-center" data-id="element-2933">
          <p className="text-[13px] text-[#aaaaaa] leading-[1.7]" data-id="element-2934">
            &copy; 2026 AppEmbrace, Inc. d/b/a Caveo. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}